// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left',
        suggestionStyle2MainContainerSelector: '.predictive-search .drawer__content',
        suggestionMobileStyle: 'style2',
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  	InstantSearchResultItemProduct.prototype.customizeProductTitle = function() {
		// Override this method for customization
      	var title = this.title;
      	if (boostPFSAppConfig.general.current_locale == 'en') {
			title = Utils.getProductMetafield(this.data, 'product-fields', 'page_title_en') !== null ? Utils.getProductMetafield(this.data, 'product-fields', 'page_title_en') : title;
        } else if (boostPFSAppConfig.general.current_locale == 'fr') {
          	title = Utils.getProductMetafield(this.data, 'product-fields', 'page_title_fr') !== null ? Utils.getProductMetafield(this.data, 'product-fields', 'page_title_fr') : title;
        }
		return title;
	}
    
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_min, window.themeVariables.settings.moneyWithCurrencyFormat);
      
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min, window.themeVariables.settings.moneyWithCurrencyFormat);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.formatMoney(price, window.themeVariables.settings.moneyWithCurrencyFormat);
              	compareAtPrice = Utils.formatMoney(compareAtPrice, window.themeVariables.settings.moneyWithCurrencyFormat);
			}
		}
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
            if (this.data.price_min != this.data.price_max) {
				result = '<p class="{{class.searchSuggestion}}-product-price">' +
							'<span class="{{class.searchSuggestion}}-product-regular-price">'+window.themeVariables.strings.from.replace('{{ price_min }}', '{{regularPrice}}')+'</span>' +
						 '</p>';
            } else if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
              	result = '<p class="boost-pfs-search-suggestion-product-price">' +
                  			  '<span class="boost-pfs-search-suggestion-product-sale-price">{{regularPrice}}</span>' +
                              '&nbsp;<s>{{compareAtPrice}}</s>' +
                          '</p>';
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
	}
    
    InstantSearchResult.prototype._applyFilterAutocompleteAppendElement = function(element) {
		this.appendToSelector = Settings.getSettingValue('search.suggestionStyle2MainContainerSelector');
	}
    
    InstantSearchResult.prototype.render = function() {
		if (this.isFirstLoad) {
			// Render initial suggestion container and append it to the dom
			var suggestionHtml = this.compileTemplate();
          	this.appendToSelector = Utils.isMobile() ? '.predictive-search .drawer__content' : 'body';
			this._applyFilterAutocompleteAppendElement();

			jQ(this.appendToSelector).append(suggestionHtml);
			this.$wrapper = jQ(this.selector.wrapper);
			this.$popoverElement = jQ(this.selector.popover);
			this.isFirstLoad = false;
		} else {
          	this.appendToSelector = Utils.isMobile() ? '.predictive-search .drawer__content' : 'body';
			this._applyFilterAutocompleteAppendElement();
			// Show the suggestion popover
			this.$instantSearchResult.siblings().show();
			// Render suggestion blocks and items
			if (this.isLoading) {
				this._renderSuggestionLoading();
				this._renderWrapper();
			} else {
				this._renderWrapper();
				this._renderSuggestion();
			}
		}
	}

    Utils.buildProductItemUrl = function(data, hasCollection) {
    	// Get url information
    	var params = Utils.getWindowLocation().search.substring(1);
    	var pathname = window.location.pathname;
    	var elements = pathname.split('/');
    
    	// Check if has locale
    	var localeURLPart = "";
    	var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    	if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
    		localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    	} else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
    		localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
    	}
    
    	// Get product handle
    	var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
    	var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
    	if (hasCollection) {
    		// Homepage or Search page
    		if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
    			var preHandle = localeURLPart + '/collections/all/products/';
    			return preHandle + handle;
    
    		// Tag Page
    		} else if (Utils.isTagPage()) {
    			var preHandle = localeURLPart + '/collections/';
    			var collectionHandleIndex = elements.indexOf("collections") + 1
    			if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
    			return '/collections/all/products/' + handle;
    		} else {
    			// Google cache URL
    			// An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
    			if (params.indexOf('cache:') > -1) {
    				var collectionHandle = 'all';
    				var temp = params.split('&')[0].split('?')[0].split('collections/');
    				if (temp.length > 1) {
    					if (temp[1].indexOf('/') > -1) {
    						collectionHandle = temp[1].split('/')[0];
    					}
    					else {
    						collectionHandle = temp[1];
    					}
    				}
    				collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
                    return '/collections/' + collectionHandle + '/products/' + handle;
    			}
              	// var collectionHandleIndex = elements.indexOf("collections") + 1;
    			// var preHandle = localeURLPart + '/collections/';
    			// if (typeof elements[2] !== 'undefined') {
    			// 	return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
    			// }
    			// return window.location.pathname + '/products/' + handle;
    		}
    	}
    	return localeURLPart + '/products/' + handle;
    };
})();